export const PLACEMENTS = {
  topRight: 'top-right',
  topCenter: 'top-center',
  topLeft: 'top-left',
  bottomRight: 'bottom-right',
  bottomCenter: 'bottom-center',
  bottomLeft: 'bottom-left',
  leftTop: 'left-top',
  leftCenter: 'left-center',
  leftBottom: 'left-bottom',
  rightTop: 'right-top',
  rightCenter: 'right-center',
  rightBottom: 'right-bottom',
};

export const APPEARANCES = {
  light: 'light',
  dark: 'dark',
};

export const MODES = {
  tooltip: 'tooltip',
  popover: 'popover',
};

export const MAP_PLACEMENTS_TO_FLOATING_UI_PLACEMENTS = {
  [PLACEMENTS.topCenter]: 'top',
  [PLACEMENTS.topLeft]: 'top-start',
  [PLACEMENTS.topRight]: 'top-end',
  [PLACEMENTS.rightCenter]: 'right',
  [PLACEMENTS.rightTop]: 'right-start',
  [PLACEMENTS.rightBottom]: 'right-end',
  [PLACEMENTS.bottomCenter]: 'bottom',
  [PLACEMENTS.bottomLeft]: 'bottom-start',
  [PLACEMENTS.bottomRight]: 'bottom-end',
  [PLACEMENTS.leftCenter]: 'left',
  [PLACEMENTS.leftTop]: 'left-start',
  [PLACEMENTS.leftBottom]: 'left-end',
};

export const FLOATING_OFFSET = 12;
